import { usePopup } from '@contexts/popupContext';
import { Flap } from '@models/Flap';
import React from 'react';
import { Navigate } from 'react-router-dom';
import { LockRounded } from '@mui/icons-material';
import styles from "@styles/components/TabScreen.module.css"
import { H2Title, Subtitle } from './Titles';
import designSystem from '@styles/designSystem';
import { VerticalContainer, VerticalMainContainer } from './Containers';

interface TabScreenProps {
    title: string;
    subtitle?: string;
    flaps: Flap[];
    clickedScreen: string;
    setClickedScreen: (screen: string) => void;
}

const TabScreen: React.FC<TabScreenProps> = ({ title, subtitle, flaps, clickedScreen, setClickedScreen }) => {
    const { showPopup } = usePopup();
    
    return (
        <VerticalContainer backgroundColor={designSystem.colorBackgroundGray3}>
            <VerticalContainer >
                <H2Title text={title}/>
                <Subtitle text={subtitle}/>
            </VerticalContainer>
            <div className={styles['content-container']}>
                <div className={styles['flaps-container']}>
                    {flaps.map((flap) => {
                        return (
                            <div
                                key={flap.id}
                                className={`${styles['flap']} ${clickedScreen === flap.id ? styles['clicked'] : ''} ${flap.isLocked ? styles['locked'] : ''}`}
                                onClick={() => {
                                    setClickedScreen(flap.id)
                                }}
                            >
                                {flap.label}
                            </div>
                        )}
                    )}
                </div>
                <div 
                    className={styles['inner-container']} 
                    style={{ 
                        zIndex: 1,
                        paddingLeft: designSystem.paddingLg,
                        paddingRight: designSystem.paddingLg,
                        paddingTop: designSystem.paddingZero
                    }}
                >
                    {flaps.find(flap => flap.id === clickedScreen)?.content}
                </div>
            </div>

        </VerticalContainer>
        // <div className={styles['content-block']}>
        // </div>
    );
};

interface TabScreenWrapperProps extends TabScreenProps { 
}

const TabScreenWrapper: React.FC<TabScreenWrapperProps> = ({ title, subtitle, flaps, clickedScreen, setClickedScreen }) => {
    return <TabScreen title={title} subtitle={subtitle} flaps={flaps} clickedScreen={clickedScreen} setClickedScreen={setClickedScreen} />;
};

export { TabScreenWrapper };
